<template>
  <BaseTemplate>
    <div class="confirm-user-register">
      <Title jpn="Check input info" />

      <SubTitle>Name</SubTitle>
      <div class="box">
        <LabelItem
          class="label-item"
          :text="fullName"
        />
      </div>

      <LabelItem
        class="label-item"
        label="Country"
        :text="countryName"
      />
      <LabelItem
        class="label-item"
        label="Zip code"
        :text="$route.query.zipCode"
      />
      <LabelItem
        v-if="i18n_mode != 'jp'"
        class="label-item"
        label="Prefecture"
        :text="$route.query.country"
      />
      <LabelItem
        class="label-item"
        label="City"
        :text="$route.query.shiku"
      />
      <LabelItem
        class="label-item"
        label="Address1"
        :text="$route.query.address"
      />
      <LabelItem
        class="label-item"
        label="Address2"
        :text="$route.query.building"
      />

      <SubTitle>Tel</SubTitle>
      <div class="box">
        <LabelItem
          class="label-item"
          :text="$route.query.tel"
        />
      </div>

      <SubTitle>Email address</SubTitle>
      <div class="box">
        <LabelItem
          class="label-item"
          :text="$route.query.mail"
        />
      </div>

      <SubTitle>Password</SubTitle>
      <div class="box">
        <LabelItem
          class="label-item"
          :text="dispPassword"
        />
      </div>

      <!-- <SubTitle>Referral Code</SubTitle>
      <div class="box">
        <LabelItem
          class="label-item"
          :text="$route.query.referralCode"
        />
      </div> -->

      <div class="button-area">
        <SquareButton
          class="square-button"
          text="Back"
          :isSub="true"
          @handleSquareBtnClick="goToUserRegister"
        />
        <BlackGradationButton
          class="square-button"
          text="Confirm"
          @handleSquareBtnClick="register"
        />
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import LabelItem from '@/components/molecules/LabelItem.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title.vue';
import SubTitle from '@/components/molecules/SubTitle.vue';
import t from '@/plugins/i18n';

export default {
  name: 'ConfirmUserRegister',
  mixins: [t],

  components: {
    BaseTemplate,
    SquareButton,
    LabelItem,
    BlackGradationButton,
    Title,
    SubTitle,
  },

  computed: {
    ...mapGetters({
      prefectureList: 'prefecture/prefectureList',
      appendUserResult: 'user/appendUserResult',
      countryList: 'country/countryList',
    }),
    fullName() {
      if (this.i18n_mode === 'jp') {
        return `${this.$route.query.lastName} ${this.$route.query.firstName}`;
      }
      return `${this.$route.query.lastName} ${this.$route.query.middleName} ${this.$route.query.firstName}`;
    },
    dispPassword() {
      if (this.$route.query.password) {
        const passwordLength = this.$route.query.password.length;
        const dispPassword = Array(passwordLength + 1).join('●');
        return dispPassword;
      }
      return '';
    },
    prefectureName() {
      if (this.prefectureList) {
        return this.prefectureList.find(
          (prefecture) => prefecture.id === this.$route.query.prefectureId,
        ).name;
      }
      return null;
    },
    countryName() {
      if (this.countryList) {
        return this.countryList.find(
          (country) => country.id === this.$route.query.countryId,
        ).name;
      }
      return null;
    },
  },

  watch: {
    appendUserResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearAppendUserResult');
          this.$router.push('complete-user-register');
        }
      }
    },
  },

  created() {
    this.$store.dispatch('prefecture/setPrefectureList');
    this.$store.dispatch('country/setCountryList');
  },

  methods: {
    goToUserRegister() {
      const query = {
        lastName: this.$route.query.lastName,
        middleName: this.$route.query.middleName,
        firstName: this.$route.query.firstName,
        tel: this.$route.query.tel,
        mail: this.$route.query.mail,
        zipCode: this.$route.query.zipCode,
        prefectureId: this.$route.query.prefectureId,
        country: this.$route.query.country,
        shiku: this.$route.query.shiku,
        address: this.$route.query.address,
        building: this.$route.query.building,
        password: this.$route.query.password,
        confirmPass: this.$route.query.confirmPass,
        referralCode: this.$route.query.referralCode,
        countryId: this.$route.query.countryId,
      };
      this.$router.push({ path: '/user-register', query });
    },
    register() {
      const postParams = {
        lastName: this.$route.query.lastName,
        middleName: this.$route.query.middleName,
        firstName: this.$route.query.firstName,
        tel: this.$route.query.tel,
        mail: this.$route.query.mail,
        zipcode: this.$route.query.zipCode,
        pref_id: this.$route.query.prefectureId,
        country: this.$route.query.country,
        shiku: this.$route.query.shiku,
        address: this.$route.query.address,
        building: this.$route.query.building,
        pass: this.$route.query.password,
        confirmPass: this.$route.query.confirmPass,
        referralCode: this.$route.query.referralCode,
        country_id: this.$route.query.countryId,
      };
      this.$store.dispatch('user/appendUser', { postParams });
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-user-register{
  width: 100%;
  max-width: 600px;
  min-height: 100%;
  padding: 50px 30px;
  margin: 0px auto;
  @include appendMap($backgroundStyleMap);
  .description{
    display: inline-block;
    color: $black;
    height: 20px;
    margin-top: 30px;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 23.4px;
    text-align: center;
    width: 100%;
    margin-bottom: 20px;
  }
  .label-item{
    width: 100%;
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0px;
    padding-bottom: 10px;
    color: $white;
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    .square-button{
      width: 120px;
      height: 50px;
      & + .square-button{
        margin-left: 30px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .confirm-user-register{
    padding: 20px 10px 20px;
    .description{
      margin-top: 10px;
      padding-left: 20px;
    }
    .button-area{
      margin-top: 20px;
      .square-button {
        & + .square-button {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
